// Carries into print deliberately: no no-print class. Same first two lines as
// the presented sheet, so the two client-facing artefacts say the same thing,
// plus an attribution line for the holdings data.

const LINES = [
  'Investment advisory and financial planning services are offered through Pure Financial Advisors, LLC, an SEC Registered Investment Advisor.',
  'This assessment is based on client-provided information that has not been independently verified. Pure Financial Advisors assumes no liability for errors or omissions due to incomplete or inaccurate data.',
];

export default function AssessmentDisclosure({ bundle }) {
  return (
    <div className="asmt-disclosure">
      {LINES.map((line, i) => <p key={i}>{line}</p>)}
      {bundle?.source && (
        <p>
          Holdings, expense ratio and classification data provided by {bundle.source}
          {bundle.asOf ? `, as of ${bundle.asOf}` : ''}. Figures shown assume no
          investment growth and are illustrative, not a projection of future
          results.
        </p>
      )}
    </div>
  );
}
